"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FacilityFeeText = exports.SlotsLoadingAvailability = exports.NoAvailabilityText = exports.NoAvailabilityContainer = exports.LocationAddressRow = exports.LocationName = exports.LocationContainer = exports.LocationsContainer = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
exports.LocationsContainer = (0, styled_1.default)('div') `
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.LocationContainer = (0, styled_1.default)('div') `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.LocationName = (0, styled_1.default)('h3') `
  margin: 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  line-height: 1.5;
`;
exports.LocationAddressRow = (0, styled_1.default)('p') `
  margin: 0 0 ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  line-height: 1.5;
`;
exports.NoAvailabilityContainer = (0, styled_1.default)('div') `
  margin: ${(0, ui_theme_1.fromTheme)('spacing_large')} 0;
`;
exports.NoAvailabilityText = (0, styled_1.default)('p') `
  margin: 0;
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
`;
exports.SlotsLoadingAvailability = (0, styled_1.default)('div') `
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_large')};
`;
exports.FacilityFeeText = (0, styled_1.default)('div') `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
//# sourceMappingURL=styles.js.map